import { Directive } from '@angular/core';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { InstrumentType } from '@zero/shared/util-models';

@Directive({})
export class SavingPlanMostChosenListBase {
  public readonly type = InstrumentType;
  public currentType = InstrumentType.Etf;

  constructor(public savingsPlanFacade: SavingsPlanFacade) {}
}
